"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Types = void 0;
var Types;
(function (Types) {
    Types["Bool"] = "boolean";
    Types["Function"] = "function";
    Types["Number"] = "number";
    Types["BigInt"] = "bigint";
    Types["Object"] = "object";
    Types["String"] = "string";
    Types["Symbol"] = "symbol";
    Types["Undefined"] = "undefined";
    /**Type is one of 'boolean|number|bigint|object|string|symbol' */
    Types["NotFunction"] = "notfunction";
})(Types = exports.Types || (exports.Types = {}));
//# sourceMappingURL=Enums.js.map